import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { Checklist } from '@/domain/models/Checklist'
import { Result } from '@/domain/protocols/Result'

import type { IChecklistRepository } from '@/data/ChecklistRepository/IChecklistRepository'

export class SaveChecklistUseCase implements UseCase<Checklist, Promise<Result<void>>> {
  private repository: IChecklistRepository

  constructor(repository?: IChecklistRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IChecklistRepository>(InjectionTokens.ChecklistRepository)
  }

  async execute(checklist: Checklist): Promise<Result<void>> {
    try {
      if (!checklist) return Result.fail('CHECKLIST_INVALID')

      // Optimistic stamp: it is sent to the server, but the stored value is the server's own clock
      // and the write does not echo the record back. Good enough to order the list locally.
      checklist.updatedAt = new Date()

      return await this.repository.saveChecklist(checklist)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
